const gsapHomeHero = () => {
  gsap.registerPlugin(ScrollTrigger);

  const loadTl = gsap.timeline({ delay: 0.2 });

  loadTl
    .fromTo(
      '.js-home-hero-bg-image-left',
      { opacity: 0 },
      { opacity: 1, duration: 0.5, ease: 'power2.out' },
    )
    .fromTo(
      '.js-home-hero-bg-image-right',
      { opacity: 0 },
      { opacity: 1, duration: 0.5, ease: 'power2.out' },
    )
    .to('.js-home-hero-bg-image-left', { opacity: 0.7, duration: 1, ease: 'power2.out' })
    .to('.js-home-hero-bg-image-right', { opacity: 0.7, duration: 1, ease: 'power2.out' }, '-=1')
    .fromTo(
      '.js-home-hero-text',
      { opacity: 0, y: 20 },
      { opacity: 1, y: 0, duration: 1, ease: 'power2.out' },
      '-=1',
    )
    .fromTo(
      '.js-home-hero-buttons',
      { opacity: 0 },
      { opacity: 1, duration: 0.5, ease: 'power2.out' },
    );

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: '.js-home-hero',
      start: 'top top',
      end: '+=100%',
      scrub: 1,
    },
  });

  tl.to('.js-home-hero', {
    zIndex: 0,
    filter: 'blur(10px)',
    opacity: 0.3,
    duration: 2,
  });
};
window.addEventListener('DOMContentLoaded', () => {
  const hero = document.querySelector('.js-home-hero');
  if (hero) gsapHomeHero();
});
